<template>
    <div v-if="this.$route.name == 'displayPage'">
    </div>
    <div v-else>
        <div><h1>Library</h1></div>
        <div>
            <router-link to="/">CONVERT</router-link>|
            <router-link to="/convert_crypt">BASE64(CryptJS)</router-link>|
            <router-link to="/convert_atob">BASE64(atob/tob)</router-link>
        </div>
        <div>header:{{this.$route.name}}</div>
        <hr>
    </div>
</template>
<script>
    export default {
        name: "GlobalHeader",
        components: {
        }
    }
</script>